import { Button } from '@/components/ui/button';

interface InlineEditActionsProps {
  onCancel: () => void;
  onSave?: () => void;
  className?: string;
  /**
   * Show "Enter to save" hint. Set to false for textarea (multiline) fields.
   * Default: true (for single-line inputs)
   */
  showEnterHint?: boolean;
  /**
   * Show explicit Save button. Use for complex inputs that don't support blur-save.
   * Default: false
   */
  showSaveButton?: boolean;
}

/**
 * Action buttons for inline editing of text fields.
 * Uses onMouseDown to prevent blur-save before cancel fires.
 */
export function InlineEditActions({
  onCancel,
  onSave,
  className = '',
  showEnterHint = true,
  showSaveButton = false
}: InlineEditActionsProps) {
  return (
    <div className={`flex gap-2 mt-2 ${className}`}>
      {showSaveButton && onSave && (
        <Button
          variant="default"
          size="sm"
          type="button"
          onClick={onSave}
          data-testid="inline-edit-save"
        >
          Save
        </Button>
      )}
      <Button
        variant="outline"
        size="sm"
        type="button"
        onMouseDown={(e) => {
          // Use onMouseDown to fire before blur event
          // This prevents blur-save from running before cancel
          e.preventDefault();
          onCancel();
        }}
        data-testid="inline-edit-cancel"
      >
        Cancel
      </Button>
      <p className="text-xs text-muted-foreground flex items-center">
        {showEnterHint && (
          <>
            <kbd className="px-1.5 py-0.5 text-xs bg-muted rounded border">Enter</kbd>
            <span className="mx-1">to save,</span>
          </>
        )}
        <kbd className="px-1.5 py-0.5 text-xs bg-muted rounded border">Esc</kbd>
        <span className="mx-1">to cancel</span>
      </p>
    </div>
  );
}
